<template>
  <el-cascader
    v-model="cascaderVal"
    :options="options_data"
    :props="selectProps"
    :disabled="disabled"
    @change="handleChange"></el-cascader>
</template>

<script>
export default {
  name: 'v-cascader',
  props:{
    value: {
      type: [String, Number,Array],
      default: ''
    },
    disabled:{
      type:Boolean,
      default:false
    },
    showAll:{
      type:Boolean,
      default:false
    },
    selectProps:{
      type:Object,
      default:()=>{
        return{
          value:'id',
          label:'name',
          children:'class'
        }
      }
    },
    list:{
      type:Array,
      default:()=>([])
    }
  },
  data(){
    return{
      cascaderVal: [],
      options_data: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val !== this.inputValue) {
          if (this.checkValue(val) || this.checkValue(this.inputValue)) {
            this.cascaderVal = val
          }

        }
      }
    },
    list:{
      immediate: true,
      deep: true,
      handler(val){
        let temp = JSON.parse(JSON.stringify(val))
        // 剔除id=0的选项
        if(val.length > 0){
          val.forEach((item, i) => {
            if(this.showAll)
              temp[i].class = item.class
            else
              temp[i].class = item.class.filter(class_item => class_item.id > 0)
          })
        }
        this.options_data = temp
      }
    }
  },
  methods:{
    handleChange(value) {
      this.$emit('input',value)
      this.$emit('change',value)
    },
    checkValue(value) {
      if(value === '' || value === null) {
        return false
      }
      return true
    },
  }
}
</script>

<style scoped lang="scss">

</style>
